/**
 * User: WangMeng
 * Date: 2018-04-16
 * Time: 9:46
 * Desc: 监管动态搜索
 */

import commonStyles from '../../common/common.scss';
import React, { PureComponent } from 'react';
import { Form, Select } from 'antd';
import cns from 'classnames';
import { debounce } from '../../../../../utils/debounce';

// import { dateFormat } from '../../../../../utils/formatter';
const FormItem = Form.Item;
const Option = Select.Option;

class SearchForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            options: {}
        };
    }

    componentDidMount() {
        this.setOptions();
    }

    componentWillReceiveProps(nextProps) {
        this.setOptions(nextProps);
    }

    componentWillUnmount() {
        this.syncSearch.cancel();
    }

    setOptions = (props = this.props) => {
        const { options, onFail } = props;
        if (!this.initialized && (options || options === false)) {
            this.initialized = true;
            if (options) {
                this.setState({
                    options
                }, () => {
                    this.onSubmit();
                });
            } else { // option请求失败
                onFail && onFail();
            }
        }
    };

    onSubmit = (e) => {
        e && e.preventDefault();
        const { onSearch } = this.props;
        const { validateFields } = this.props.form;

        validateFields({ force: true }, (err, values) => {
            if (!err) {
                onSearch && onSearch(values);
            }
        });
    };

    syncSearch = debounce(() => {
        this.onSubmit();
    }, 300);

    render() {
        const { getFieldDecorator } = this.props.form;
        const { options } = this.state;

        const { reportYear = [] } = options;
        return (
            <div className={cns('search-bar', commonStyles.searchBar)}>
                <Form hideRequiredMark layout="inline" onSubmit={this.onSubmit}>
                    <FormItem>
                        {getFieldDecorator('reportYear', {
                            initialValue: reportYear[0]
                        })(
                            <Select size="default" onChange={this.syncSearch}>
                                {reportYear.map(d => <Option key={d} value={d}>{d}</Option>)}
                            </Select>
                        )}
                    </FormItem>
                </Form>
            </div>
        );
    }
}

export default (Form.create({})(SearchForm));



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/riskHint/trends/SearchForm.jsx